import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-loading-state"},[_c(VProgressLinear,{attrs:{"indeterminate":"","color":"primary"}}),(_vm.message)?_c('p',{staticClass:"base-loading-state__message"},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }